import { OidcProvider, loadUser as oidcLoadUser, userFound } from "redux-oidc";
import fetch from "isomorphic-fetch";
import qs from "querystring";
import get from "lodash.get";
import jwt_decode from "jwt-decode";

let AuthProvider = OidcProvider;
let loadUser = oidcLoadUser;
let initialState = {};
const params = qs.parse(window.location.search.substring(1));

if (process.env.REACT_APP_NOAUTH) {
  AuthProvider = ({ children }) => children;
  loadUser = loadUserFn;
  initialState = {
    oidc: {
      user: null,
      isLoadingUser: true
    }
  };
}

if(params.Credential && params.Organization)
{
  AuthProvider = ({ children }) => children;
  loadUser = loadExternalUserFn;
  initialState = {
    oidc: {
      user: null,
      isLoadingUser: true
    }
  };
}

export { AuthProvider, loadUser, initialState };

async function loadUserFn(store) {
  const user = get(
    require("../package.json"),
    "cypress.oidc_user",
    "AutomatedTestUser"
  );

  const response = await fetch(
    "https://dispatch-login-dev.apps-dev.usdc10.axadmin.net/connect/token",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: qs.stringify({
        grant_type: "password",
        client_id: "Fees.WebAutoTest",
        client_secret: "AutomatedTest",
        scope: "SMAppServices",
        username: user,
        password: "password"
      })
    }
  ).then(response => response.json());

  store.dispatch(
    userFound({
      id_token: "__testvalue__",
      session_state: "__testvalue__",
      access_token: response.access_token,
      token_type: "__testvalue__",
      scope: "__testvalue__",
      profile: {
        sid: "__testvalue__",
        sub: user,
        auth_time: 1540306285,
        idp: "local",
        amr: ["pwd"],
        "user.organization":
          '{"Id":"Audatex","BusinessCategory":"INS","Name":"Audatex"}',
        "user.entity": [
          `{"LdapId":"AUDATEX,Administrator:${user}","Role":"Administrator","Country":"US"}`,
          `{"LdapId":"AUDATEX,Domain Administrators:${user}","Role":"Domain Administrators","Country":"US"}`
        ],
        "user.profile": `{"Id":"${user}","Name":"${user}","Email":null,"FirstName":"Automated","MiddleName":null,"LastName":"Test"}`
      },
      expires_at: 1640378195
    })
  );
}

async function loadExternalUserFn(store) {

  const response = await fetch(
    `${window.__AUTH_SERVER__}connect/token`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: qs.stringify({
        grant_type: "delegation",
        client_id: "Fees.Web",
        client_secret: "AuthADXE2FeesWeb20",
        scope: "openid profile SMAppServices",
        token: `Credential=${params.Credential}&Organization=${params.Organization}`
      })
    }
  ).then(response => response.json());

  if(response.access_token){
    var decoded = jwt_decode(response.access_token);
    store.dispatch(
      userFound({
        id_token: "__ExternalAuth__",
        session_state: "__ExternalAuth__",
        access_token: response.access_token,
        token_type: "__ExternalAuth__",
        scope: "__ExternalAuth__",
        profile: {
          sid: "__ExternalAuth__",
          sub: decoded.sub,
          auth_time: 1540306285,
          idp: "local",
          amr: ["pwd"],
          "user.organization": decoded["user.organization"],
          "user.entity": decoded["user.entity"],
          "user.profile": decoded["user.profile"]
        },
        expires_at: decoded.exp
      })
    );
  }
  else{
    window.location.href = "/";
  }
}